import { Component, inject, type OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import dayjs from 'dayjs';
import { TitleService } from '../title.service';

@Component({
  selector: 'app-site-stats-chart',
  templateUrl: './site-stats-chart.component.html',
  styleUrls: ['./site-stats-chart.component.scss'],
  standalone: false,
})
export class SiteStatsChartComponent implements OnInit {
  private titleService = inject(TitleService);

  dateRange = new FormGroup({
    start: new FormControl('', {
      nonNullable: true,
    }),
    end: new FormControl('', {
      nonNullable: true,
    }),
  });
  chartOptions: string[] = [
    'Today',
    'Week-Hourly',
    'Week-Daily',
    'Past 4 weeks',
    'Year',
    'All',
    'Custom',
  ];
  defaultOption = 'Week-Daily';
  customOption: boolean;
  start?: number;
  end?: number;
  selectedType: string;

  ngOnInit() {
    this.titleService.set('Charts - Super admin');
    this.start = dayjs().subtract(7, 'days').startOf('day').valueOf();
    this.end = dayjs().endOf('day').valueOf();
    this.selectedType = 'Week-Daily';
  }

  selectedDateFormat(selectedType) {
    if (selectedType !== 'Custom') {
      this.selectedType = selectedType;
      this.customOption = false;
      if (selectedType === 'Today') {
        this.start = dayjs().subtract(1, 'days').startOf('hour').valueOf();
        this.end = dayjs().endOf('hour').valueOf();
      } else if (
        selectedType === 'Week-Daily' ||
        selectedType === 'Week-Hourly'
      ) {
        this.start = dayjs().subtract(7, 'days').startOf('day').valueOf();
        this.end = dayjs().endOf('day').valueOf();
      } else if (selectedType === 'Past 4 weeks') {
        this.start = dayjs().subtract(28, 'days').startOf('day').valueOf();
        this.end = dayjs().endOf('day').valueOf();
      } else if (selectedType === 'Year') {
        this.start = dayjs().subtract(1, 'year').valueOf();
        this.end = dayjs().valueOf();
      } else if (selectedType === 'All') {
        this.start = undefined;
        this.end = undefined;
      }
    } else {
      this.customOption = true;
    }
  }
  customEndDateInput() {
    if (this.dateRange.value.end) {
      this.start = dayjs(this.dateRange.value.start).startOf('day').valueOf();
      this.end = dayjs(this.dateRange.value.end).endOf('day').valueOf();
      this.selectedType = 'Custom';
    }
  }
}
